import { SyntheticEvent } from "react"
import { ToitEnPenteLayers } from "@iko-design-center/shared"
import { useTranslation } from "react-i18next"
import {
  allSelectedDownloadState,
  getLayerOptions,
} from "../../../store/toit-en-pente/download"
import { useToitEnPente } from "../../../store/toit-en-pente/hooks"
import { useModal } from "../../../store/modal/hooks"

type ToggleAllOptions = "DOP" | "technicalFiche"

export function useDownload() {
  const { setDownloadState, downloadState } = useToitEnPente()
  const { closeModal, displayToitEnPenteDownloadMailModal } = useModal()
  const { t } = useTranslation()

  function selectAll() {
    setDownloadState(allSelectedDownloadState)
  }

  function handleCardClick(e: SyntheticEvent) {
    e.stopPropagation()
  }

  const technicalFicheOptions = getLayerOptions({
    t,
    state: downloadState.technicalFiche,
  })
  const DOPOptions = getLayerOptions({
    t,
    state: downloadState.DOP,
  })

  function toggleAll(kind: ToggleAllOptions) {
    switch (kind) {
      case "technicalFiche":
        const technicalFicheChecked =
          downloadState.technicalFiche.toitInsulation

        setDownloadState({
          ...downloadState,
          technicalFiche: {
            toitInsulation: !technicalFicheChecked,
          },
        })
        break
      case "DOP":
        const DOPChecked = downloadState.DOP.toitInsulation

        setDownloadState({
          ...downloadState,
          DOP: {
            toitInsulation: !DOPChecked,
          },
        })
        break
    }
  }

  function toggleLayersOption(
    kind: ToggleAllOptions,
    value: ToitEnPenteLayers
  ) {
    switch (kind) {
      case "technicalFiche":
        setDownloadState({
          ...downloadState,
          technicalFiche: {
            ...downloadState.technicalFiche,
            [value]: !downloadState.technicalFiche[value],
          },
        })
        break
      case "DOP":
        setDownloadState({
          ...downloadState,
          DOP: {
            ...downloadState.DOP,
            [value]: !downloadState.DOP[value],
          },
        })
        break
    }
  }

  function toggle(
    kind:
      | "specifications"
      | "BIMFile"
      | "screenshots"
      | "thermalCalculation"
      | "processingGuideline"
  ) {
    setDownloadState({
      ...downloadState,
      [kind]: !downloadState[kind],
    })
  }

  function handleDownload() {
    displayToitEnPenteDownloadMailModal()
  }

  return {
    t,
    handleCardClick,
    closeModal,
    selectAll,
    technicalFicheOptions,
    toggleAll,
    toggleLayersOption,
    DOPOptions,
    downloadState,
    toggle,
    handleDownload,
  }
}
